<div class="container" style="">
  <carousel [isAnimated]="true">

    <!-- <slide >
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1695249792/Banner/2023HOResourceFair_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1  class="carousel__title">HOMEOWNERS’ RESOURCE FAIR:<br>OCTOBER 14, 2023</h1> -->
        <!-- <h4 class="carousel__description">{{'Home.Christmas' | translate}}</h4>
        <h4 class="carousel__description">{{'Home.NewYear' | translate}}</h4> -->
        <!-- <h4 class="carousel__description">Learn about Parent-Child Transfers (Prop. 19), Property Tax Savings Programs, Death of a Property Owner, ADUs, and more.</h4>
        <a class="carousel__link" href="https://forms.office.com/g/SN3nn1977j" target="_blank"  >REGISTER TODAY <span><i class="fas fa-angle-right"></i></span></a> -->
        <!-- <a class="carousel__link" routerLink="/tax-relief/decline-in-value"  >{{'Home.ApplyToday' | translate}} <span><i class="fas fa-angle-right"></i></span></a> -->
       <!-- </div>

    </slide> -->

    <!-- <slide  style="">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1702395317/Banner/2024JAN_HRF_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1 class="carousel__title">HOMEOWNERS’ RESOURCE FAIR:<br>SANTA CLARITA | JAN. 20, 2024</h1>
        <h4 class="carousel__description">Learn about Parent-Child Transfers (Prop. 19), Property Tax Savings Programs, Death of a Property Owner, Misfortune and Calamity, Tax Relief, and more.</h4>
        <a class="carousel__link" routerLink="/news-information/events"  >{{'Home.LearnMore' | translate}} <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide> -->

    <!-- <slide  style="">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1710877724/Banner/2024ChiquitaCanyonLandfill_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1 class="carousel__title" [innerHTML]="'HomepageBanner.ChiquitaCanyon'|translate"></h1>
        <h4 class="carousel__description">{{'HomepageBanner.Chiquitadesc' | translate}}<br></h4>
        <a class="carousel__link" routerLink="/tax-relief/decline-in-value" >{{'HomepageBanner.LearnmoreDIV' | translate}} <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide> -->

    <!--M&C Form-->
    <slide style="">
      <!-- <img src="../../assets/banner_disaster_relief.jpg" alt="first slide" style="display: block;  width: 100%"> Fire Banner -->
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1744931989/Banner/2025M_C_Status_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <!-- <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1672955189/Banner/2023DisasterRelief_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% "> -->

      <div class="carousel-caption ">
        <h1 class="carousel__title">{{'Home.MncClaimStatus' | translate}}</h1>
        <h4  class="carousel__description" [innerHTML]="'Home.MncClaimStatusDesc'|translate"> {{'Home.MncClaimStatusDesc'|translate}} </h4>
        <a class="carousel__link" routerLink="/homeowners/property-search">{{'Home.MncPropLink' | translate}} <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide>

    <!--Disaster Relief Webinar to Events Page-->
    <!-- <slide  style="">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1741277272/Banner/2025DisasterReliefWebinar_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1 class="carousel__title" [innerHTML]="'HomepageBanner.DisasterReliefResourceFair'|translate"></h1>
        <h4 class="carousel__description">{{'HomepageBanner.HearfromAssessor-4/27/25' | translate}}<br></h4>
        <a class="carousel__link" routerLink="/news-information/events" >{{'Home.RegisterToday' | translate}} <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide> -->

    <!--571L To Events Page-->
    <!-- <slide  style="">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1648242285/Banner/571-L_webinar_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1 class="carousel__title" [innerHTML]="'HomepageBanner.571LBanner3-20-2023'|translate"></h1>
        <h4 class="carousel__description">{{'HomepageBanner.571L3-20-2023Desc' | translate}}<br></h4>
        <a class="carousel__link" routerLink="/news-information/events" >{{'Home.RegisterToday' | translate}} <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide> -->

<!--  571 L Banner Hidden 5/6/2024
    <slide  style="">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1710352609/Banner/2024_571L_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1 class="carousel__title">Business Personal Property Statements<br>Due April 1, 2024</h1>
        <h4 class="carousel__description">Avoid a 10% penalty by filing by May 7, 2024</h4>
        <a class="carousel__link" routerLink="/businessowners/business-prop-statement-filing" >Learn More<span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide> -->

    <!-- <slide  style="">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1711046000/Banner/BoatVesselOwnerTownHall_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1 class="carousel__title" [innerHTML]="'HomepageBanner.Boats3212024'|translate"></h1>
        <h4 class="carousel__description">{{'HomepageBanner.Boars3212024desc' | translate}}<br></h4>
        <a class="carousel__link" routerLink="/news-information/events" >{{'Events.Register' | translate}} <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide> -->

    <!--Resource Fair Banner HIDDEN-->
    <!-- <slide  style="">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1727966191/Banner/2024NOV_HRF_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1 class="carousel__title" [innerHTML]="'Home.OctHOR2024Title'|translate"></h1>
        <h4 class="carousel__description">{{'Home.OctHOR2024Desc' | translate}}</h4>
        <a class="carousel__link" routerLink="/news-information/events" >{{'Home.ViewEvent' | translate}} <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide> -->

     <!-- Homeowner Alert Service -->
    <!-- <slide  style="">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1727374208/Banner/2024eFileExpanded_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1 class="carousel__title">Expanded E-File Services</h1>
        <h4 class="carousel__description">{{'Home.ExpandedEfile' | translate}}</h4>
        <a class="carousel__link" routerLink="/forms"  >{{'View Forms' | translate}} <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide> -->

    <!-- Homeowner Alert Service -->
    <!-- <slide  style="">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1669926856/Banner/2022DCBAeNotification_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1 class="carousel__title">Homeowner <span style="color: #FF757E;">Alert</span> Service (E-Notification)</h1>
        <h4 class="carousel__description">{{'Home.ENoticeRegister' | translate}}</h4>
        <a class="carousel__link" routerLink="/news-information/enotification"  >{{'Home.LearnMore&Register' | translate}} <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide> -->

    <!--M&C Form-->
    <slide style="">
      <!-- <img src="../../assets/banner_disaster_relief.jpg" alt="first slide" style="display: block;  width: 100%"> Fire Banner -->
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1738248008/Banner/M_C_eForm_webBanner.jpg" alt="first slide" style="display: block; width: 100% ">
      <!-- <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1672955189/Banner/2023DisasterRelief_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% "> -->

      <div class="carousel-caption ">
        <h1 class="carousel__title">{{'Home.M&CEform' | translate}}</h1>
        <h4  class="carousel__description" [innerHTML]="'Home.M&CEformDesc'|translate"> {{'Home.M&CEformDesc'|translate}} </h4>
        <a class="carousel__link" routerLink="/contact/assessor/3 ">{{'Home.FileHere' | translate}} <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide>

    <!--Disaster Relief -->
    <slide style="">
      <!-- <img src="../../assets/banner_disaster_relief.jpg" alt="first slide" style="display: block;  width: 100%"> Fire Banner -->
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1672955306/Banner/DisasterRelief_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <!-- <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1672955189/Banner/2023DisasterRelief_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% "> -->

      <div class="carousel-caption ">
         <h1 class="carousel__title">{{'Home.DisasterTitlev2' | translate}}</h1>
        <h4  class="carousel__description"> {{'Home.DisasterDescription'|translate}} <a href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1736540235/Factsheet/Relief_for_Properties_Impacted_By_A_Disaster.pdf" target="_blank" style="color: #76E57A">{{'Relief for Properties Impacted By A Disaster'|translate}}</a></h4>
        <a class="carousel__link" routerLink="/tax-relief/disaster-relief">{{'Home.DisasterLink' | translate}} <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide>

    <!-- Change of Mailing Address Hidden for now------------------------------- -->
    <!-- <slide >
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1688436330/Banner/2023eFileCMA_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1  class="carousel__title">CHANGE OF MAILING ADDRESS FORM E-FILE</h1>
        <h4 class="carousel__description">Property owners seeking to change their mailing address can now submit their requests online. The Change of Mailing Address form is available online in a new submittable format.</h4>
        <a class="carousel__link" routerLink="/forms"  >VIEW FORMS <span><i class="fas fa-angle-right"></i></span></a>
        </div>

    </slide> -->

    <!--Disabled Veterans DVX-->
    <!-- <slide  style="">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1715619889/Banner/2024_DVX_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1 class="carousel__title">DISABLED VETERANS' EXEMPTION</h1>
        <h4 class="carousel__description">{{'Home.DVXBanner' | translate}}</h4>
        <a class="carousel__link" routerLink="/exemptions/disabled-veterans" >{{'Home.LearnMore&Apply' | translate}} <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide> -->

    <!-- Decline in Value Banner -->
    <!-- <slide >
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1656682983/Banner/2022DIV_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1  class="carousel__title">{{'Home.DIV2022title' | translate}}</h1> -->
        <!-- <h4 class="carousel__description">{{'Home.Christmas' | translate}}</h4>
        <h4 class="carousel__description">{{'Home.NewYear' | translate}}</h4> -->
        <!-- <h4 class="carousel__description">{{'Home.DIV2024v2' | translate}}</h4>
        <a class="carousel__link" href="https://assessor.lacounty.gov/div"  >{{'Home.ApplyToday' | translate}} <span><i class="fas fa-angle-right"></i></span></a> -->
        <!-- <a class="carousel__link" routerLink="/tax-relief/decline-in-value"  >{{'Home.ApplyToday' | translate}} <span><i class="fas fa-angle-right"></i></span></a> -->
       <!-- </div>

    </slide> -->

    <!--Prop 19 Slide -->
    <!-- <slide  style="">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/c_scale,w_1374/v1623789290/News/banner_prop19.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1 class="carousel__title">Proposition 19</h1>
        <h4 class="carousel__description">{{'Home.Prop19Description2' | translate}}</h4>
        <a class="carousel__link" routerLink="/exclusions/prop19" >{{'Home.Prop19Link' | translate}} prop. 19 <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide> -->

    <!-- Tax Bill hidden for now -->
    <!-- <slide  style="">
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1699912978/Banner/2023TTCviewBill_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1 class="carousel__title">Need a Copy of Your Tax Bill?</h1>
        <h4 class="carousel__description">Our colleagues at the Los Angeles County Treasurer and Tax Collector have made it easy to see a property’s tax bill.</h4>
        <a class="carousel__link" href="https://ttc.lacounty.gov/request-duplicate-bill/" target="_blank" >View Property Tax Bill <span><i class="fas fa-angle-right"></i></span></a>
      </div>
    </slide> -->













    <!-- <slide >
      <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1653407461/Banner/2022NACoAward_webBanner_1400x500.jpg" alt="first slide" style="display: block; width: 100% ">
      <div class="carousel-caption ">
        <h1  class="carousel__title">{{'Home.AssessorWins' | translate}}</h1>
        <h4 class="carousel__description">{{'Home.AssessorOfficeWon' | translate}}</h4>
        <a class="carousel__link" href="https://us11.campaign-archive.com/?u=3d79962a0e2ac6a48c94d04e8&id=c63c532a82" target="_blank">{{'Home.LearnMore' | translate}} <span><i class="fas fa-angle-right"></i></span></a>
      </div>

    </slide> -->

    <!-- <slide style="">
      <a href="http://google.com" target="_blank" >
      <img src="../../assets/banner_vaccinateLA.jpg"  alt="first slide" style="display: block; width: 100%">

      </a>

    </slide> -->

  </carousel>
  <app-findProperty [title]="'PropertySearch.FindProperty' | translate" (ParcelItem)="getAddress($event)"></app-findProperty>

  <app-programs></app-programs>
</div>
